import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogContent,
    Typography,
    Button,
    Grid,
    DialogTitle,
    DialogActions,
    FormControl,
    Select,
    MenuItem,
    FormHelperText,
} from "@material-ui/core";
import { connect, ConnectedProps } from "react-redux";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { ClusterProviders } from "../../constants/clusterconstants"
import { AppConstants } from "../../constants/appconstants"
import { getProviderConfig, importCluster, updateCluster } from './redux/actions'
import MuiTextField from "../../components/textfield/MuiTextField";
import MultiValueChipInput from "../../components/emailinput/MultiValueChipInput";
import { validateRegex } from "../../helpers/utils" 
import { useTranslation } from 'react-i18next';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import FileUpload from "../../components/fileupload/Fileupload";
import { Dispatch } from "redux";
import { Transition } from "../../helpers/utils.ext";

const generalRegex  = "^[a-z0-9-]*$"
const generalHelperText = "Allowed only lowercase characters, numbers and hyphen"

interface Props extends PropsFromRedux{
    closeHandler: () => void,
    successHandler: (data: any) => void,
    edit?: boolean,
    cluster?: any,
    open: boolean
}

type RegionList = {
    items: string[],
    description: string
}

export const ClusterImportPopup = (props: Props) => {
    const [provider, setProvider] = useState<string>("Select");
    const [name, setName] = useState<string>("");
    //const [isClusterNameError, setIsClusterNameError] = useState(false);
    const [properties, setProperties] = useState<any>(null);
    const [region, setRegion] = useState<string>("Select");
    const [regionList, setRegionList] = useState<RegionList | null>(null);
    const [zone, setZone] = useState("Select");
    const [zoneList, setZoneList] = useState<string[] | null>(null);
    const [labels, setLabels] = useState<string[] | any>([]);
    //const [label, setLabel] = useState("");
    //const [error, setError] = useState(false);
    const [errors, setErrors] = useState<any>({});
    const [helperTexts, setHelperTexts] = useState<any>({});
    const [selectedFile, setSelectedFile] = useState<any>(null);
    const [providerName, setProviderName] = useState<string>("");
    // const [registry, setRegistry] = useState(0);
    const [ t ] = useTranslation();

    const handleClose = () => {
        props.closeHandler();
    };

    const handleSuccessImport = (data?: any) => {
        props.successHandler(data);
    }

    const handleImport = () => {
        const _labels = labels.join(',')
        let jsonBody
        let _provider = provider
        if(provider === AppConstants.ClusterProvider.Other){
            _provider = AppConstants.ClusterProvider.Other;
        }
        if(!props.edit){
            jsonBody = new FormData(); 
            jsonBody.append("provider", _provider);
            jsonBody.append("provider_name", _provider === "other" ? providerName : _provider);
            jsonBody.append("name", name);
            jsonBody.append("region", region);
            jsonBody.append("zone", zone !== "Select" ? zone : "");
            jsonBody.append("labels", _labels);

            // jsonBody.append('image_repo_service', "");
            // jsonBody.append('image_repo_username', "");
            // jsonBody.append('image_repo_password', "");
            // jsonBody.append('image_repo_project', "");
            // jsonBody.append('image_registry_id', registry);
            jsonBody.append('dns_zone', "");

            jsonBody.append('file', selectedFile);
            props.importCluster(jsonBody, handleSuccessImport);
        }else if(props.edit){
            jsonBody = {
                provider: _provider,
                provider_name: _provider==="other"?providerName:_provider,
                cluster_name: name,
                region:region,
                zone: zone === "Select" ? "" : zone,
                labels: _labels,
                // image_registry_id: registry,
                // image_repo_service: "",
                // image_repo_username: "",
                // image_repo_password: "",
                // image_repo_project: "",
                dns_zone: "",
            }
            props.updateCluster(props.cluster?.id, jsonBody, props.edit, handleSuccessImport)
        }
    };

    const handleProviderChange = (e: React.ChangeEvent<{ name?: string; value: unknown }>) => {
        setProvider(e.target.value as string);
        // if(e.target.value !== "Select"){
        //     props.getProviderConfig(e.target.value);
        // }
        setRegion("Select")
        setZone("Select")
    }

    const handleClusterNameChange = (e: React.ChangeEvent<{ name: string; value: unknown }>) => {
        setName(e.target.value as string);
        // if(e.target.getAttribute('regex')){
        //     setIsClusterNameError(validateRegex(e.target.value, e.currentTarget.getAttribute('regex')) ? false : true);
        //     setErrors({
        //         ...errors,
        //         [e.target.name] : validateRegex(e.target.value, e.currentTarget.getAttribute('regex')) ? false : true
        //     })
        //     setHelperTexts({
        //         ...helperTexts,
        //         [e.target.name]: properties?.cluster_name?.description
        //     })
        // }else{
        //     setIsClusterNameError(validateRegex(e.target.value, generalRegex) ? false : true);

        // }
        let regx
        if(properties?.cluster_name?.validation){
            regx = properties?.cluster_name?.validation
        }else{
            regx = generalRegex
        }
        setErrors({
            ...errors,
            [e.target.name] : validateRegex(e.target.value, regx) ? false : true
        })
        setHelperTexts({
            ...helperTexts,
            [e.target.name]:  !validateRegex(e.target.value, regx) ? properties?.cluster_name?.description ? properties?.cluster_name?.description  : generalHelperText : ""
        })
        // setRegion("Select")
        // setZone("Select")
    }

    const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            const _file = e.target.files[0];
            if (_file) { //&& _file.size <= 102400
                setSelectedFile(_file)
            }
        }
    }

    useEffect(() => {
        if(props.providerConfig)
        {
            const _properties = props.providerConfig && props.providerConfig.properties;
            if(_properties){
                setProperties(_properties);
                if(_properties.region){
                    setRegionList(_properties.region);
                }
            }
        }
    }, [props.providerConfig]);

    useEffect(() => {
        if(props.cluster && props.edit){
            setProvider(props.cluster?.provider ? props.cluster?.provider : props.cluster?.cluster?.provider)
            setRegion(props.cluster?.region ? props.cluster?.region : props.cluster?.cluster?.region)
            setName(props.cluster.cluster_name)
            setZone(props.cluster?.zone ? props.cluster?.zone : props.cluster?.cluster?.zone)
            setProviderName(props.cluster?.provider ? props.cluster?.provider_name : props.cluster?.cluster?.provider_name)
            if(props.cluster.cluster?.labels?.trim().length){
                setLabels(props.cluster.cluster?.labels?.split(','))
            }
        }
    }, [props.edit, props.cluster])

    useEffect(() => {
        if(provider !== "Select" && provider !==  AppConstants.ClusterProvider.Other){
            props.getProviderConfig(provider);
        }
        if(provider === AppConstants.ClusterProvider.Other && !props.edit){
            // setName("")
            setRegion("")
            setZone ("")
            // setProviderNameError(false)
            // setRegionError(false)
            // setZoneError(false)
        }
    }, [provider])

    useEffect(() => {
        let regx
        if(properties?.zone?.validation){
            regx = properties?.zone?.validation
        }else{
            regx = generalRegex
        }
        setErrors({
            ...errors,
            zone : validateRegex(zone, regx) ? false : true
        })
        setHelperTexts({
            ...helperTexts,
            zone:  !validateRegex(zone, regx) ? properties?.zone?.description ? properties?.zone?.description  : generalHelperText : ""
        })
    }, [zone])

    useEffect(() => {
        let regx
        if(properties?.provider?.validation){
            regx = properties?.provider?.validation
        }else{
            regx = generalRegex
        }
        setErrors({
            ...errors,
            providerName : validateRegex(providerName, regx) ? false : true
        })
        setHelperTexts({
            ...helperTexts,
            providerName:  !validateRegex(providerName, regx) ? properties?.provider?.description ? properties?.provider?.description  : generalHelperText : ""
        })
    }, [providerName])

    useEffect(() => {
        let regx
        if(properties?.region?.validation){
            regx = properties?.region?.validation
        }else{
            regx = generalRegex
        }
        setErrors({
            ...errors,
            region : validateRegex(region, regx) ? false : true
        })
        setHelperTexts({
            ...helperTexts,
            region:  !validateRegex(region, regx) ?( properties?.region?.description ? properties?.region?.description  : generalHelperText) : ""
        })
        
        if(region === "Select"){
            setZoneList(null);
        }
        else {
            if(properties && properties.zone)
            {
                setZoneList(properties.zone.items && properties.zone.items.filter((zn : string) => zn.startsWith( region )));        
            }
        }
        // if(props.edit){
        //     const z = zoneList?.find(_z => {return props.cluster?.cluster?.zone === _z})
        //     if(z){
        //         setZone(props.cluster?.cluster?.zone)
        //     }else if(zoneList && zoneList[0]){
        //         setZone(zoneList[0])
        //     }    
        // }else{
        //     setZone("Select")
        // }
    }, [region, properties]);

    useEffect(() => {
        if(props.edit){
            const z = zoneList?.find((_z: string) => {return props.cluster?.cluster?.zone === _z})
            if(z){
                setZone(props.cluster?.cluster?.zone)
            }else if(zoneList && zoneList[0]){
                setZone(zoneList[0])
            }
        }else if(provider !== AppConstants.ClusterProvider.Other){
            setZone("Select")
        }
    }, [zoneList])

    const isFormValid = () => {
        let valid = false;
        let e  = false
        Object.keys(errors).forEach(k => {
            if(errors[k]){
                e = true
                return
            }
        })
        if(name.trim() !== "" //&& !isClusterNameError
            && provider !== "Select"
            && region !== "Select"
            && region !== ""
            && labels !== "" 
            && !e
            && (selectedFile || props.edit))
        {
            if( provider === AppConstants.ClusterProvider.GCP)
            {
                if(zone !== "Select")
                {
                    valid = true;
                }
            }
            else {
                valid = true;
            }
        }
        return !valid;    
    }

    const handleLabelsChange = (newLabels: any) => {
        setLabels(newLabels)
    }

    // const handleRegistryChange = (value) => {
    //     setRegistry(value);
    // }

    return (
        <Dialog
          open={props.open}
          TransitionComponent={Transition}
          onClose={() => handleClose()}
          keepMounted
          data-test="dialog-container"
        >
            <DialogTitle>
                <Typography className="dialogtitle" variant="h6" data-test="dialog-title">{t('Cluster.ClusterImportPopup.importCluster')}</Typography>

                <IconButton
                  aria-label="close"
                  size="small"
                  className="right"
                  onClick={handleClose}
                  data-test="close-icon"
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Grid container spacing={2} >
                                <Grid item xs={12} md={ provider !== "Select" ? 6 : 12}>
                                    {provider !== "Select" && <Typography variant='body1' >{t('Cluster.ClusterDNS.provider')}</Typography>}

                                    <FormControl className="w-100" variant="outlined" margin="normal">
                                        <Select
                                          name='provider'
                                          value={ provider }
                                          color='primary'
                                          onChange={handleProviderChange}
                                          MenuProps={{
                                                getContentAnchorEl: null,
                                                anchorOrigin: {
                                                    vertical: "bottom",
                                                    horizontal: "left"
                                                }
                                            }}
                                            data-test="provider-select"
                                        >
                                            <MenuItem value="Select">{t('Cluster.ClusterDNS.selectProvider')}</MenuItem>
                                        
                                            {
                                                ClusterProviders && ClusterProviders.length > 0 && ClusterProviders.map((item, ind) => 
                                                    <MenuItem value={ item.provider } key={ ind }>{ item.name }</MenuItem>
                                                    )
                                                }
                                            <MenuItem value="other">{t('Cluster.ClusterImportPopup.other')}</MenuItem>
                                        </Select>
                                        {/* <FormHelperText >{ _region && _region.description }</FormHelperText> */}
                                    </FormControl>
                                </Grid>
                                {
                                    provider !== "Select" && 
                                    <>
                                        <Grid item xs={12} md={6}>
                                            <Typography variant='body1'>{t('Cluster.ClusterImportPopup.clusterName')}</Typography>

                                            <MuiTextField
                                              name="name"
                                              value={ name }
                                              onChange = { (e) => handleClusterNameChange(e)}
                                              type="text"
                                              margin="normal"
                                              inputProps = {{
                                                    regex: properties && properties.cluster_name && properties.cluster_name.validation 
                                                }}
                                              data-test="name-field"
                                              error = { errors.name}
                                              helperText = {
                                                    helperTexts.name
                                                    //  isClusterNameError && properties && properties.cluster_name && properties.cluster_name.description  
                                                    }
                                              placeholder={"Cluster Name"}

                                            />

                                        </Grid>
                                        {provider ===  AppConstants.ClusterProvider.Other &&
                                            <Grid item xs={12} md={12}>
                                                <Typography variant='body1' >{t('Cluster.ClusterImportPopup.providerName')}</Typography>

                                                <MuiTextField
                                                  name="providerName"
                                                  value={ providerName }
                                                  onChange = { (e) => setProviderName(e.target.value)}
                                                  type="text"
                                                  margin="normal"
                                                  inputProps = {{
                                                        regex: properties && properties.cluster_name && properties.cluster_name.validation 
                                                    }}
                                                  data-test="provider-name-field"
                                                  error = { errors.providerName}
                                                  helperText= { helperTexts.providerName}
                                                    // helperText = { isClusterNameError && properties && properties.cluster_name && properties.cluster_name.description }
                                                  placeholder={"Provider Name"}

                                                />

                                            </Grid>
                                        }

                                        <Grid item xs={12} sm={6}>
                                            <Typography variant='body1' >{t('Cluster.ClusterDNS.region')}</Typography>
                                            { provider !== AppConstants.ClusterProvider.Other && (
                                                <FormControl className="w-100" variant="outlined" margin="normal">
                                                    <Select
                                                      name='region'
                                                      value={ region }
                                                      color='primary'
                                                      onChange={ (e: React.ChangeEvent<{ value: unknown }>) => setRegion(e.target.value as string) }
                                                      data-test="region-field"

                                                      MenuProps={{
                                                            disableScrollLock: true,
                                                            getContentAnchorEl: null,
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "left"
                                                            }
                                                        }}
                                                    >
                                                        <MenuItem value="Select">{t('Cluster.ClusterDNS.selectRegion')}</MenuItem>
                                                        {
                                                            regionList && regionList.items && regionList.items.length > 0 &&
                                                            regionList.items.map((reg: string, ind: number) => <MenuItem value={ reg } key={ ind }>{ reg }</MenuItem>)
                                                        }
                                                    </Select>
                                                    <FormHelperText >
                                                        { regionList && 
                                                            <>
                                                                <InfoOutlinedIcon style={{width: 16, height: 16}}/>
                                                                <Typography variant="caption">{regionList.description}</Typography>
                                                            </>     
                                                        }
                                                    </FormHelperText>
                                                </FormControl>

                                            ) }
                                            { provider === AppConstants.ClusterProvider.Other &&
                                            (
                                                <MuiTextField 
                                                  className="w-100" 
                                                  variant="outlined" 
                                                  margin="normal"
                                                  name='region'
                                                  value={ region }
                                                  data-test="other-region-field"
                                                  inputProps = {{
                                                        regex: properties && properties.cluster_name && properties.cluster_name.validation 
                                                    }}
                                                  color='primary'
                                                  onChange={ (e) => setRegion(e.target.value) }
                                                  placeholder={"Cluster Region"}
                                                  error={errors.region}
                                                  helperText = {helperTexts.region}
                                                />          
                                            )}

                                            {/* <FormHelperText >{ regionList && regionList.description }</FormHelperText> */}
                                        </Grid>

                                        {
                                            provider === AppConstants.ClusterProvider.GCP &&
                                            <Grid item xs={12} sm={6}>
                                                <Typography variant='body1' >{t('Cluster.ClusterDNS.zone')}</Typography>

                                                <FormControl className="w-100"  variant="outlined" margin="normal">
                                                    <Select
                                                      name='zone'
                                                      value={ zone }
                                                      color='primary'
                                                      onChange={(e: React.ChangeEvent<{ name?: string; value: unknown }>) => setZone(e.target.value as string) }
                                                      data-test="zone-field"
                                                      MenuProps={{
                                                            disableScrollLock: true,
                                                            getContentAnchorEl: null,
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "left"
                                                            }
                                                        }}
                                                    >
                                                        <MenuItem value="Select">{t('Cluster.ClusterDNS.selectZone')}</MenuItem>
                                                        {
                                                            zoneList && zoneList.length > 0 && zoneList.map((zn: string, ind: number) => <MenuItem value={ zn } key={ ind }>{ zn }</MenuItem>)
                                                        }
                                                    </Select>
                                                    <FormHelperText>
                                                        { properties && properties.zone && 
                                                            <>
                                                                <InfoOutlinedIcon style={{width: 16, height: 16}}/>
                                                                <Typography variant="caption">{properties.zone.description}</Typography>
                                                            </>
                                                        }
                                                    </FormHelperText>
                                                </FormControl>
                                            </Grid>
                                        }
                                        {
                                            provider === AppConstants.ClusterProvider.Other &&
                                            <Grid item xs={12} sm={6}>
                                                <Typography variant='body1' >{t('Cluster.ClusterDNS.zone')}</Typography>
                                                <MuiTextField 
                                                  className="w-100" 
                                                  variant="outlined" 
                                                  margin="normal"
                                                  name='zone'
                                                  value={ zone }
                                                  data-test="other-zone-field"
                                                  inputProps = {{
                                                        regex: properties && properties.cluster_name && properties.cluster_name.validation 
                                                    }}
                                                  color='primary'
                                                  onChange={ (e) => setZone(e.target.value) }
                                                  placeholder={"Cluster Zone"}
                                                  error={errors.zone}
                                                  helperText = {helperTexts.zone}
                                                />  
                                            </Grid>
                                        }
                                        {/* <Grid item xs={12} sm={6}>
                                            <Typography variant='h5' >Registry</Typography>
                                            <ClusterRegistry isInForm isCreateMode={true} handleRegistryChange={ handleRegistryChange } data-test="cluster-registry"/>
                                        </Grid> */}
                                        <Grid item xs={12}>
                                            <Typography variant='body1' > {provider === AppConstants.ClusterProvider.Other ? "Config File" : "JSON config file" }</Typography>
                                            {/* <TextField
                                              id=""
                                              type="file"
                                              title=""
                                              color="primary"
                                              name=""
                                              variant="outlined"
                                              className="w-100"
                                              margin="normal"
                                              data-test="file-field"
                                              onChange={ (e) => onFileChange(e) }
                                              disabled = {props.edit}
                                            /> */}
                                            <FileUpload onChange={onFileChange} disabled = {props.edit} selectedFile={selectedFile} data-test="file-field"/>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant='body1'>{t('Cluster.ClusterImportPopup.labels')}</Typography>
                                            <br />
                                            <MultiValueChipInput data-test="multivalue-chip-field" handleValues={handleLabelsChange} values={labels} disabled={props.edit} />
                                        </Grid>

                                    </>
                                }
                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                  onClick={() => handleImport()}
                  color="primary"
                  variant="contained"
                  disabled = { isFormValid() }
                  data-test="submit-button"
                >
                    {props.edit ? "Edit" : "Import"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

/* istanbul ignore next */
const mapStateToProps = (state: any) => ({
    providerConfig: state.ClusterReducer.providerConfig
});
  
/* istanbul ignore next */
const mapDispatchtoProps = (dispatch: Dispatch) => {
    return {
        getProviderConfig: (provider: string) => dispatch(getProviderConfig(provider)),
        importCluster: (formData: FormData, callback: (data?: any) => void) => dispatch(importCluster(formData, callback)),
        updateCluster: (id: number, formData: any, edit: boolean, handleSuccessImport: (data?: any) => void) => dispatch(updateCluster(id, formData, edit, handleSuccessImport))
    };
};

const connector = connect(mapStateToProps, mapDispatchtoProps);
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(ClusterImportPopup);